
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";

import api from "@/api";
import filter from "@/utils/filter";
import { AuditUserLog, AuditUserLogStatus } from "@/api/appService";

@Component
export default class AuditUserLogs extends Vue {
  @Watch("show")
  async onShowChange(value: boolean) {
    if (value) {
    } else {
    }
  }

  logs: AuditUserLog[] = [];

  private internalLogs: any = [];

  show = false;

  @Watch("logs")
  onLogsChange(newValue: AuditUserLog[]) {
    if (newValue && newValue.length) {
      this.internalLogs = [];
      for (let i = 0; i < newValue.length; i++) {
        let logItem: any = newValue[i];
        if (logItem.type === "Deduction") {
          logItem.hasRevoked = false;
          for (let j = 0; j < newValue.length; j++) {
            let checkItem = newValue[j];
            if (checkItem.id === logItem.id) continue;
          }
        }
        this.internalLogs.push(logItem);
      }
    } else {
      this.internalLogs = newValue;
    }
  }

  cancel() {
    this.show = false;
  }

  formatNodeText(log: AuditUserLog) {
    return log.desc;
  }
  // log types

  formatCreationTime(time: string) {
    return filter.formatDate(time, undefined);
  }

  formatNodeType(log: AuditUserLog) {
    // primary / success / warning / danger / info
    switch (log.status) {
      case AuditUserLogStatus.Continue:
        return "default";
      case AuditUserLogStatus.Reject:
        return "danger";
      case AuditUserLogStatus.Pass:
        return "success";
      default:
        return "default";
    }
  }
  formatLogIcon(log: AuditUserLog) {
    switch (log.status) {
      case AuditUserLogStatus.Continue:
        return "el-icon-alarm-clock";
      case AuditUserLogStatus.Reject:
        return "el-icon-postcard";
      case AuditUserLogStatus.Pass:
        return "el-icon-unlock";
      default:
        return "el-icon-question";
    }
  }
}
